import { __spreadArrays } from "tslib";
import { bitRates, byteRates, deprecatedByteRates, } from "../constants";
import { matchUnit } from "./util";
export var dataRateFormatUnits = [
    bitRates,
    byteRates,
    // deprecated
    deprecatedByteRates,
];
export var dataRateFormatUnitIds = [].concat.apply([], dataRateFormatUnits.map(function (dataRateFormatUnitGroup) { return __spreadArrays(dataRateFormatUnitGroup.map(function (dataRateFormatUnit) { return dataRateFormatUnit.id; }), [].concat.apply([], dataRateFormatUnitGroup.map(function (dataRateFormatUnit) {
    return dataRateFormatUnit.alias ? dataRateFormatUnit.alias : [];
}))); }));
export function humanizeDataRateValue(value, unit, targetUnit) {
    var baseDataRateUnitGroupIndex = dataRateFormatUnits.length - 1;
    var baseDataRateUnitIndex = 0;
    var targetDataRateUnitIndex = -1;
    var sign = Math.sign(value);
    var positiveValue = Math.abs(value);
    if (unit) {
        var _loop_1 = function (i) {
            var _baseDataRateUnitIndex = -1;
            var _targetDataRateUnitIndex = -1;
            dataRateFormatUnits[i].forEach(function (dataRateUnit, index) {
                if (matchUnit(dataRateUnit, unit))
                    _baseDataRateUnitIndex = index;
                if (matchUnit(dataRateUnit, targetUnit))
                    _targetDataRateUnitIndex = index;
            });
            if (_baseDataRateUnitIndex !== -1) {
                baseDataRateUnitGroupIndex = i;
                baseDataRateUnitIndex = _baseDataRateUnitIndex;
                targetDataRateUnitIndex = _targetDataRateUnitIndex;
                return "break";
            }
        };
        for (var i = 0; i < dataRateFormatUnits.length; ++i) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
    }
    else if (targetUnit) {
        targetDataRateUnitIndex = dataRateFormatUnits[baseDataRateUnitGroupIndex].findIndex(function (dataRateUnit) { return matchUnit(dataRateUnit, targetUnit); });
    }
    var dataRateFormatUnitGroup = dataRateFormatUnits[baseDataRateUnitGroupIndex];
    var baseDataRateFormatUnit = dataRateFormatUnitGroup[baseDataRateUnitIndex];
    var targetDataRateFormatUnit = baseDataRateFormatUnit;
    if (targetDataRateUnitIndex === -1) {
        for (var i = baseDataRateUnitIndex + 1; i < dataRateFormatUnitGroup.length; ++i) {
            if (positiveValue /
                (dataRateFormatUnitGroup[i].divisor /
                    baseDataRateFormatUnit.divisor) >=
                1) {
                targetDataRateFormatUnit = dataRateFormatUnitGroup[i];
            }
            else {
                break;
            }
        }
    }
    else {
        targetDataRateFormatUnit = dataRateFormatUnitGroup[targetDataRateUnitIndex];
    }
    if (targetUnit && targetDataRateUnitIndex === -1) {
        console.warn("Cannot convert unit \"" + (unit || baseDataRateFormatUnit.display) + "\" to \"" + targetUnit + "\"");
    }
    return [
        (positiveValue /
            (targetDataRateFormatUnit.divisor / baseDataRateFormatUnit.divisor)) *
            sign,
        targetDataRateFormatUnit.display,
    ];
}
//# sourceMappingURL=dataRate.js.map